import { FC } from 'react';
import { IconButton } from '../iconButton';
import ContainerElementTop from 'shared/assets/icons/arrowTop.svg';

interface Props {
	onClick: () => void;
}

export const ArrowTopIconButton: FC<Props> = ({
	onClick,
}) => {
	return (
		<IconButton
			role="arrow-top-button"
			iconSrc={ContainerElementTop}
			onClick={onClick}
		/>
	);
};
